import en from './strings.en';

const ru = {
    drop: 'Сбросить',
    more: 'Ещё',
    total: 'Всего'
};

export default { ru, en: { ...ru, ...en} };
